module.exports = __webpack_public_path__ + "img/ic-kkpoints.285e6f2d.png";